import { render, staticRenderFns } from "./ContactTeaser.vue?vue&type=template&id=4d8cc0e7&scoped=true"
import script from "./ContactTeaser.vue?vue&type=script&lang=js"
export * from "./ContactTeaser.vue?vue&type=script&lang=js"
import style0 from "./ContactTeaser.vue?vue&type=style&index=0&id=4d8cc0e7&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8cc0e7",
  null
  
)

export default component.exports